import config from './config'

export default {
    /*
        GET     /api/v1/dealers
    */
    getDealers: function (address = null, page = 1, units = 'mi', category = null, coordinates = false) {
        let params = {
            location: address,
            page: page,
            units: units,
            category: category
        };
        if (coordinates) {
            params.lat = coordinates.latitude;
            params.lng = coordinates.longitude;
            params.location = null;
        }
        return axios.get(config.API_URL + '/dealers', {
            params: params
        });
    },

    getDealerCategories: function () {
        return axios.get(config.API_URL + '/dealer-categories');
    },
}